import Vuex, { StoreOptions } from 'vuex'

import { IRootState } from '@/@types'
import Vue from 'vue'
import app from './modules/app'
import auth from './modules/auth'
import business from './modules/business'
import coupons from './modules/coupons'
import events from './modules/events'
import featureFlags from './modules/featureFlags'
import priceDetails from './modules/priceDetails'
import products from './modules/products'
import shoppingCart from './modules/shopping-cart'
import subscriptions from './modules/subscriptions'
import recurly from './modules/recurly'

Vue.use(Vuex)

const store: StoreOptions<IRootState> = {
  modules: {
    app,
    auth,
    business,
    coupons,
    events,
    featureFlags,
    priceDetails,
    products,
    shoppingCart,
    subscriptions,
    recurly,
  },
}

export default new Vuex.Store<IRootState>(store)
